import lazyload from '@/utility/lazyload';

export default {
  inserted: lazyload,
};
